import {Lang} from 'yougile-lang'
import {MenuItem} from './types'

export const getMultiSelectText = <T>({
  value,
  options,
  allText = Lang.msg.component.dropdown.all
}: {
  value: T[]
  options: MenuItem<T>[]
  allText?: string
}): string | undefined => {
  if (!value) {
    return undefined
  }
  if (value.length === options.length) {
    return allText
  }
  if (value.length === 1) {
    return options.find(x => x.value === value[0])?.label
  }
  return `${Lang.msg.component.dropdown.selected} ${value.length} ${Lang.msg.component.dropdown.outOf} ${options.length}`
}

export const getSelected = <T>(
  value: T | T[],
  item: T,
  multi: boolean
): boolean => {
  return multi && Array.isArray(value) ? value.includes(item) : value === item
}

export const getAllState = <T>(
  value: T | T[] | undefined,
  items: MenuItem<T>[]
): boolean | undefined => {
  if (!Array.isArray(value)) {
    return undefined
  }
  if (!value) {
    return undefined
  }
  if (value.length === items.length) {
    return true
  }
  return value.length === 0 ? false : undefined
}
